import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useAuthDataContext } from "./auth-provider";
import { useApi } from "./api";
import { useAppContext } from "./appContext/app-provider";
import { Tenant } from "./appContext/app-model";
import LinearProgress from "@material-ui/core/LinearProgress";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

interface ListarTenantsResponse {
    data: { [id: string]: string }
}

export const useTenants = () => {
    const { actions, model } = useAppContext();
    const { api } = useApi();
    const { user, onRefreshToken } = useAuthDataContext();

    const [tnts, setTnts] = useState<Tenant[]>(model.tenants ?? []);
    const [currentTenant, setCurrentTenant] = useState<Tenant | undefined>(undefined);

    useEffect(() => {
        if (model.tenants) {
            setTnts(model.tenants);
        }
    }, [model.tenants]);

    useEffect(() => {
        if (user && tnts.length > 0) {
            const thisTenant = tnts.filter(x => x.value === user.tenantId)[0];
            setCurrentTenant({ ...thisTenant });
        } else {
            setCurrentTenant(undefined);
        }
    }, [user, tnts]);

    if (tnts.length === 0) {

        const loadTenants = async () => {
            const { data } = await api.get<ListarTenantsResponse>('listar_tenants');
            const tenants = data ? Object.keys(data.data).map(x => ({ value: x, name: data.data[x] })) : [];
            actions.setTenants(tenants);
        }

        loadTenants();
    }

    // NOTA: Alguns bug conhecidos da troca de tenant:
    // 1) Os requests via useFetcher(SWR) da dashboard que falharem para o novo tenant, exibirão dados anteriores
    // 2) ao deslogar com um usuario com multiplos tenant e entrar com um novo usuario os tenants anteriores serao exibidos (mas nao selecionaveis)
    // 3) Por motivos desconhecidos os o hub da automacao tambem tras dados do tenant anterior em caso de retorno com erro

    const changeUserTenant = useCallback((tenant: Tenant) => {
        const targetTenant = tenant.value;
        setCurrentTenant(undefined);
        api.post<{ tenantAtual: string; }>(`change_tenant/${targetTenant}`).then(resp => {
            if (resp.status === 200 && onRefreshToken) {
                onRefreshToken();
                // window.location.reload();
            }
        }).catch(error => {
            if (error.response) {
                alert(error.response.data);
            }

        });

    }, [onRefreshToken, api]);

    return useMemo(() => ({ tenants: tnts, currentTenant, changeUserTenant }), [tnts, currentTenant, changeUserTenant]);
}

export const TenantSelector = () => {
    const { tenants, currentTenant, changeUserTenant } = useTenants();

    const [anchorMenu, setAnchorMenu] = useState<null | HTMLElement>(null);

    const handleMenuButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorMenu(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorMenu(null);
    }

    const handleMenuItemClick = (option: any) => {
        setAnchorMenu(null);
        changeUserTenant(option as Tenant);
    }

    return (
        <div>
            {tenants.length > 1 ?
                <div>
                    <Button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleMenuButtonClick}
                        variant="contained"
                    >
                        {currentTenant?.name ?? 'Carregando...'}
                    </Button>
                    {currentTenant === undefined && <LinearProgress />}
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorMenu}
                        keepMounted
                        open={Boolean(anchorMenu)}
                        onClose={handleMenuClose}
                    >
                        {tenants.map(fo => <MenuItem key={"item_" + fo.value} onClick={() => handleMenuItemClick(fo)}>{fo.name}</MenuItem>)}
                    </Menu>
                </div> :
                <div>
                    {currentTenant?.name ?? 'Carregando...'}
                </div>
            }
        </div>);
};
